import { render, staticRenderFns } from "./realTemplate.vue?vue&type=template&id=5544afd2&"
import script from "./realTemplate.vue?vue&type=script&lang=js&"
export * from "./realTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports